import { CustomAxiosRequestConfig } from '../services/http';

export function useCustomConfig(config: CustomAxiosRequestConfig) {
    return config;
}
